import React, { Component } from "react";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";

import classnames from "classnames";
import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  NewInputText,
  TextAreaReusableComponent,
} from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import Form from "react-bootstrap/Form";
import {
  ReusableOnboardingButton,
  ReusableOnboardingMapButton,
} from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import SuggestNewButton from "../../../vendorOnboradingComponents/reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import isEmpty from "../../../../store/validation/is-Empty";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import Media from "react-media";

export class VendorParkingEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editButton: false,
      actionButton: false,
      loader: false,
      healthdata: false,
      selectedPage: null,
      selectedTab: 2,
      parking_desc: "",
      all_parkings: [],
      selected_parking_type: [],
      primary_parking_type: {},
      errors: [],
    };
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: true,
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    // console.log(nextProps.parking_type);
    if (
      !isEmpty(nextProps.onboarding._id) &&
      !isEmpty(nextProps.parking_type) &&
      !nextState.hasSetMapProps
    ) {
      let selected_parking_type = nextProps.onboarding.selected_parking_type;
      let primary_parking_type = nextProps.onboarding.primary_parking_type;
      if (
        !isEmpty(nextProps.onboarding.primary_parking_type) &&
        !isEmpty(selected_parking_type[0])
      ) {
        if (
          nextProps.onboarding.primary_parking_type !== "" &&
          isEmpty(selected_parking_type[0]._id) &&
          selected_parking_type.length > 0 &&
          isEmpty(primary_parking_type._id)
        ) {
          selected_parking_type = nextProps.parking_type.filter((parking) =>
            selected_parking_type.includes(parking._id)
          );
          primary_parking_type = nextProps.parking_type.filter(
            (parking) => parking._id === primary_parking_type
          )[0];
        }
      }
      let all_parking_type = nextProps.parking_type.filter(
        (parking) =>
          !selected_parking_type.some(
            (selected) => selected._id === parking._id
          )
      );
      return {
        all_parkings: all_parking_type,
        selected_parking_type: !isEmpty(selected_parking_type)
          ? selected_parking_type
          : [],
        primary_parking_type: !isEmpty(primary_parking_type)
          ? primary_parking_type
          : {},
        hasSetMapProps: true,
        parking_desc: nextProps.onboarding.parking_desc,
        selectedPage: nextProps.onboarding.selectedPage,
      };
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
      actionButton: true,
    });
  };

  /********************************
   * @DESC Back Button
   ********************************/
  onBackButton = (history) => (e) => {
    e.preventDefault();
    const returnData = {
      healthdata: this.state.healthdata,
      selectedPage: this.state.selectedPage,
    };
    history.push({
      pathname: "/profile",
      state: { returnData: returnData },
    });
  };

  /****************************************
   * @DESC - Payment Method SELECTOR
   ****************************************/
  onRestaurantSelectorArraySelector = (icon, index) => (e) => {
    let buttonArray = this.state.all_parkings;
    buttonArray.splice(index, 1);
    let Restaurant = this.state.selected_parking_type;
    let primaryIcon = this.state.primary_parking_type;
    if (Restaurant.length === 0 || primaryIcon === {}) {
      Restaurant.push(icon);
      this.setState({
        selected_parking_type: Restaurant,
        primary_parking_type: icon,
        actionButton: true,
      });
    } else {
      let isAlreadyPresent = Restaurant.includes(icon);
      if (isAlreadyPresent) {
        let indexOf = Restaurant.indexOf(icon);
        if (indexOf === 0 || indexOf) {
          Restaurant.splice(indexOf, 1);
        }
      } else {
        Restaurant.push(icon);
      }
    }
    this.setState({
      selected_parking_type: Restaurant,
      actionButton: true,
    });
  };

  onRestaurantsPrimarySelector = (icon) => (e) => {
    this.setState({
      primary_parking_type: icon,
      actionButton: true,
    });
  };

  /****************************************
   * @DESC - Remove Primary button handler
   ****************************************/
  removeButton = (icon) => (e) => {
    let { all_parkings, selected_parking_type, primary_parking_type } =
      this.state;

    let iconIndexAtAllIcons = all_parkings.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconIndexAtSelectedIcons = selected_parking_type.findIndex(
      (icons) => icons._id === icon._id
    );
    let iconAtPrimaryIcon =
      !isEmpty(primary_parking_type) && primary_parking_type._id === icon._id
        ? true
        : false;
    if (selected_parking_type.length === 0) {
      selected_parking_type.push(icon);
      all_parkings.splice(iconIndexAtAllIcons, 1);
      primary_parking_type = icon;
    } else if (iconAtPrimaryIcon) {
      selected_parking_type.splice(iconIndexAtSelectedIcons, 1);
      all_parkings.push(icon);
      if (selected_parking_type.length === 1) {
        primary_parking_type = selected_parking_type[0];
      } else {
        primary_parking_type = {};
      }
    } else if (iconIndexAtSelectedIcons === 0 || iconIndexAtSelectedIcons) {
      selected_parking_type.splice(iconIndexAtSelectedIcons, 1);
      all_parkings.push(icon);
      if (selected_parking_type.length === 1) {
        primary_parking_type = selected_parking_type[0];
      }
    } else {
      selected_parking_type.push(icon);
      all_parkings.splice(iconIndexAtAllIcons, 1);
    }

    this.setState({
      selected_parking_type: selected_parking_type,
      all_parkings: all_parkings,
      primary_parking_type: primary_parking_type,
      actionButton: true,
    });
  };

  editClick = (e) => {
    this.setState({
      editButton: !this.state.editButton,
    });
  };

  onWithOutApiCall = (e) => {
    this.props.history.push({
      pathname: "/seatingdashboard",
    });
  };

  onHandleSubmit = (e) => {
    e.preventDefault();
    const formData = {
      vendor_id: this.props.onboarding.vendor_id,
      id: this.props.onboarding._id,
      selected_parking_type: this.state.selected_parking_type,
      primary_parking_type: this.state.primary_parking_type,
      parking_desc: this.state.parking_desc,
      page_completed_till: 11,
    };
    this.props.create_and_update_restaurant(formData);
    this.setState({
      actionButton: false,
    });
  };

  renderParkingMethodFields = () => {
    const {
      editButton,
      actionButton,
      errors,
      selected_parking_type,
      primary_parking_type,
      parking_desc,
    } = this.state;
    return (
      <React.Fragment>
        <div className="restaurant_type_onboarding_main">
          <div>
            <div className="cuisine-main ">
              {editButton === true ? (
                <div
                  className="cuisine-main-padding"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {this.state.all_parkings.map((icon, index) => (
                    <ReusableOnboardingMapButton
                      key={index}
                      classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                      src={icon.icon}
                      title={icon.title}
                      onClick={this.onRestaurantSelectorArraySelector(
                        icon,
                        index
                      )}
                    />
                  ))}
                  <div className="suggest-button-heading">
                    <SuggestNewButton categoryId={"5f562c9094ac7fdf47ea1d15"} />
                  </div>
                </div>
              ) : null}
              {/** */}
              {!isEmpty(selected_parking_type) && editButton === true ? (
                <h2 className="heading-title">
                  Which is your primary service for parking?
                  <small
                    id="emailHelp"
                    className="form-text text-muted input-help-textnew"
                  >
                    Select only one of the options below as a default - this is
                    shown to the user .
                  </small>
                </h2>
              ) : null}

              <div
                className="cuisine-main-padding mt-4"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {selected_parking_type.map((icon, index) => (
                  <ReusableOnboardingMapButton
                    key={index}
                    classsection={
                      icon._id === primary_parking_type._id
                        ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                        : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                    }
                    src={icon.icon}
                    title={icon.title}
                    onClick={
                      editButton === true
                        ? this.onRestaurantsPrimarySelector(icon)
                        : null
                    }
                    displayPrimary={
                      icon._id === primary_parking_type._id ? true : false
                    }
                    displayRemove={editButton === true ? true : false}
                    removeButtonClick={this.removeButton(icon)}
                  />
                ))}
              </div>
            </div>
            <div className="col-12 p-0 parking-method-mobile-bottom mb-md-5 mb-lg-5 mb-xl-5">
              <NewInputText
                extraClass=" mb-2 mt-2 "
                controlId="parking_desc"
                displayText={true}
                multiline={true}
                helpTextDisplay={true}
                labelText="Description For Parking And Accessibility"
                helperTextBottom="( If you provide free , valet or validated parking let users know here )"
                labelTextClass="text-area-lable"
                placeholder="eg. if you buy for rs. 1000 you get free parking"
                rows="4"
                onChange={this.onChange}
                onFocusOut={this.onFocusOut}
                name="parking_desc"
                value={this.state.parking_desc}
                disabled={editButton === false ? true : false}
                inputClassName={classnames("input-text-area text-area-new", {
                  invalid: errors.parking_desc,
                })}
                error={
                  this.state.parking_desc <= 0 ? errors.parking_desc : null
                }
              />
            </div>
          </div>
          <div className="col-12 p-0 d-flex justify-content-between mb-4">
            {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
            <ReusableOnboardingButton
              buttonTitle="Cancel Button"
              buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
              buttonText="Cancel"
              buttonType="button"
              onClick={this.onBackButton(this.props.history)}
            />
            {editButton === true ? (
              <ReusableOnboardingButton
                buttonTitle="Save Button"
                buttonClass={
                  selected_parking_type.length <= 0 ||
                  parking_desc === "" ||
                  parking_desc === undefined ||
                  isEmpty(primary_parking_type) ||
                  actionButton === false
                    ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray"
                    : "onboarding_button_link_reusable onboarding_button_link_reusable_red"
                }
                disabled={
                  selected_parking_type.length <= 0 ||
                  parking_desc === "" ||
                  parking_desc === undefined ||
                  isEmpty(primary_parking_type) ||
                  actionButton === false
                    ? true
                    : false
                }
                buttonText="Save"
                onClick={actionButton === false ? this.onWithOutApiCall : null}
                buttonType={actionButton === false ? "button" : "submit"}
              />
            ) : null}
            {/* </div> */}
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    const { editButton } = this.state;
    if (this.state.loader) {
      return <AmealioLoader />;
    }

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/profile"
                displayText="Back"
              />
              <div className="col-12 col-md-6 bg-transparent pt-md-0 pt-lg-0 pt-xl-0 margin-bottom-150px">
                <div className=" p-0">
                  <div>
                    <TopTextReusableComponent
                      headingText="Parking"
                      headingParagraph={
                        editButton === true
                          ? "( Select all the options through which your place is accessible )"
                          : null
                      }
                      displayEdit={editButton}
                      onClickEdit={this.editClick}
                    />
                  </div>
                  <Form noValidate onSubmit={this.onHandleSubmit}>
                    {this.renderParkingMethodFields()}
                  </Form>
                </div>
              </div>
            </div>

            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

VendorParkingEdit.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  parking_type: state.category.parking_type,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(VendorParkingEdit));
